export const GET_RICHTEXT_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    richTextBlock(id: "${id}", preview: ${preview}) {
        sys {
            id
        }
        audienceCollection{
            items{
                __typename
                sys{id}
                audianceId
              }
          }
      bodytext {
        json
        links {
            entries {
                hyperlink {
                    ... on Page {sys {id}
                        slug
                        content {
                        __typename
                        }
                    }
                    ... on FileBlock {
                        sys {
                            id
                        }
                        imageVaultFile
                        metaData
                        __typename
                    }
                }
                block {
                    __typename
                    ... on ImageBlock {
                        sys {id}
                        ivImage
                        enableZoom
                        imageDescription
                        link {
                            globalLinkItem
                            reference {
                                ...on Page {
                                    slug
                                  }
                                  ...on FileBlock
                                  {
                                    imageVaultFile
                                  }
                            }
                            url
                            newTab
                        }
                    }
                    ... on TableBlock {
                        sys {id}
                        heading
                        table
                    }
                     ... on TextList {
                        sys {id}
                        listStyle
                        texts
                        }
                }
            }
        }
      }
    }
  }
`;
